/* Official Mode I widget: https://extcall.17track.net/en. No order lookup or customer storage. */
(() => {
  'use strict';
  if (window.KaliaTrackOrder) return;
  const sdkUrl = 'https://www.17track.net/externalcall.js';
  let sdkRequest;
  class KaliaTrackOrder {
    static validate(value) {
      const raw = typeof value === 'string' ? value.trim() : '';
      if (!raw) return {error:'Enter your tracking number.'};
      if (/^#|^(?:order(?:\s*(?:number|no\.?))?|kalia|ord(?=[\s#:_-]))[\s#:_-]*\d/i.test(raw) || /^\d{1,6}$/.test(raw.replace(/ /g,''))) return {error:'Use the tracking number from your shipping email, not your order number.'};
      const number = raw.replace(/ /g,'');
      if (/[\r\n\t]/.test(raw) || !/^[A-Za-z0-9][A-Za-z0-9-]{4,49}$/.test(number) || !/\d/.test(number)) return {error:'Enter one valid tracking number.'};
      return {number};
    }
    static trackingUrl(number) {
      const valid = this.validate(number);
      if (!valid.number) return '';
      const url = new URL('https://t.17track.net/en');
      url.searchParams.set('nums',valid.number);
      return url.href;
    }
    static loadSdk() {
      if (typeof window.YQV5?.trackSingle === 'function') return Promise.resolve(window.YQV5);
      if (sdkRequest) return sdkRequest;
      sdkRequest = new Promise((resolve,reject) => {
        const script = document.createElement('script');
        let settled = false;
        const finish = (error) => {
          if (settled) return;
          settled = true; clearTimeout(timer); script.onload = null; script.onerror = null;
          if (error) { script.remove(); reject(error); }
          else resolve(window.YQV5);
        };
        const timer = setTimeout(() => finish(new Error('Tracking script timed out.')),12000);
        script.src = sdkUrl; script.async = true; script.dataset.kaliaTrackingSdk = '';
        script.onload = () => finish(typeof window.YQV5?.trackSingle === 'function' ? null : new Error('Tracking unavailable.'));
        script.onerror = () => finish(new Error('Tracking unavailable.'));
        document.head.append(script);
      }).catch(error => { sdkRequest = null; throw error; });
      return sdkRequest;
    }
    constructor(root,options = {}) {
      this.root = root;
      this.form = root.querySelector('[data-track-form]');
      this.input = root.querySelector('[data-track-input]');
      this.button = root.querySelector('[data-track-submit]');
      this.error = root.querySelector('[data-track-error]');
      this.results = root.querySelector('[data-track-results]');
      this.status = root.querySelector('[data-track-status]');
      this.container = root.querySelector('[data-track-widget]');
      this.fallback = root.querySelector('[data-track-fallback]');
      this.number = root.querySelector('[data-tracked-number]');
      if (!this.form || !this.input || !this.button || !this.results || !this.container || !this.container.id) return;
      this.loadSdk = options.loadSdk || (() => this.constructor.loadSdk());
      this.revision = 0;
      this.form.noValidate = true;
      this.root.dataset.trackState = 'idle';
      this.input.addEventListener('input',() => this.reset());
      this.form.addEventListener('submit',event => { event.preventDefault(); this.submit(); });
    }
    busy(value) {
      this.button.disabled = value;
      this.results.setAttribute('aria-busy',String(value));
    }
    message(value) {
      if (!this.status) return;
      this.status.textContent = value;
      this.status.hidden = !value;
    }
    clearWatch() {
      clearTimeout(this.widgetTimer);
      this.widgetObserver?.disconnect(); this.widgetObserver = null;
      this.frameCleanup?.(); this.frameCleanup = null;
    }
    reset() {
      this.revision += 1; this.clearWatch(); this.busy(false);
      this.input.removeAttribute('aria-invalid');
      if (this.error) { this.error.textContent = ''; this.error.hidden = true; }
      this.results.hidden = true; this.container.hidden = true; this.container.replaceChildren();
      if (this.fallback) this.fallback.hidden = true;
      this.message(''); this.root.dataset.trackState = 'idle';
    }
    fail(revision) {
      if (revision !== this.revision) return;
      this.clearWatch(); this.busy(false); this.container.hidden = true; this.container.replaceChildren();
      this.root.dataset.trackState = 'error';
      this.message('Tracking couldn’t load here. Try again or open 17TRACK.');
    }
    watchFrame(revision) {
      if (revision !== this.revision) return;
      const frame = this.container.querySelector('iframe');
      if (!frame || frame === this.frame) return;
      this.frameCleanup?.(); this.frame = frame;
      frame.setAttribute('title','17TRACK tracking results');
      const loaded = () => {
        if (revision !== this.revision) return;
        this.clearWatch(); this.busy(false); this.message('');
        this.root.dataset.trackState = 'widget-ready';
      };
      const failed = () => this.fail(revision);
      frame.addEventListener('load',loaded); frame.addEventListener('error',failed);
      this.frameCleanup = () => { frame.removeEventListener('load',loaded); frame.removeEventListener('error',failed); };
    }
    async submit() {
      this.reset();
      const revision = this.revision, valid = this.constructor.validate(this.input.value);
      if (!valid.number) {
        this.input.setAttribute('aria-invalid','true');
        if (this.error) { this.error.textContent = valid.error; this.error.hidden = false; }
        this.input.focus(); return;
      }
      this.root.dataset.trackState = 'loading'; this.results.hidden = false; this.busy(true);
      if (this.number) this.number.textContent = valid.number;
      if (this.fallback) { this.fallback.href = this.constructor.trackingUrl(valid.number); this.fallback.hidden = false; }
      this.message('Loading tracking…');
      try {
        const api = await this.loadSdk();
        if (revision !== this.revision) return;
        if (typeof api?.trackSingle !== 'function') throw new Error('Tracking unavailable.');
        this.container.hidden = false; this.frame = null;
        this.widgetObserver = new MutationObserver(() => this.watchFrame(revision));
        this.widgetObserver.observe(this.container,{childList:true});
        this.widgetTimer = setTimeout(() => this.fail(revision),20000);
        api.trackSingle({YQ_ContainerId:this.container.id,YQ_Height:560,YQ_Fc:'0',YQ_Lang:'en',YQ_Num:valid.number});
        this.watchFrame(revision);
      } catch (_) { this.fail(revision); }
    }
  }
  window.KaliaTrackOrder = KaliaTrackOrder;
  const attached = new WeakSet();
  const start = () => document.querySelectorAll('[data-track-order]').forEach(root => {
    if (attached.has(root)) return;
    attached.add(root); new KaliaTrackOrder(root);
  });
  document.addEventListener('shopify:section:load',start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
